/*
 * News-template JS. Loaded only on post, home, archive and search.
 */

/**
 * Give every heading in a news post a copyable anchor.
 */
function initHeadingAnchors() {
  const article = document.querySelector('[data-news-body]');
  if (!article) return;

  article.querySelectorAll('h2[id], h3[id]').forEach((heading) => {
    const link = document.createElement('a');
    link.className = 'heading-anchor';
    link.href = `#${heading.id}`;
    link.setAttribute('aria-label', `Link to section: ${heading.textContent.trim()}`);
    link.textContent = '#';
    heading.append(link);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeadingAnchors);
} else {
  initHeadingAnchors();
}
